<template>
    <div>
        <div style="height: 30px;width: 100%;">
            <el-button type="primary"  @click="AddClick" style="float: right;" size="medium"> 新增运用</el-button>
        </div>

        <div style="margin-top: 15px;">
            <el-card v-for='item in DataList' :key="item.ac_id" style="width: 100%;margin-bottom: 15px;">
                <div class="t">
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" >
                            <div class="a">
                                <span class="left" style="font-size: 14px;">应用appId：</span>
                                <span class="txt">{{item.ac_appid}}</span>
                            </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" >
                            <div class="a">
                                <span style="font-size: 14px;">应用名称：</span>
                                <span class="txt">{{item.ac_name}}</span>
                            </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" >
                            <div class="a">
                                <span style="font-size: 14px;">创建时间：</span>
                                <span class="txt">{{FormData(item.ac_create_time)}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="margin-top: 10px;">
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" >
                            <div class="a">
                                <span class="left" style="font-size: 14px;">应用秘钥：</span>
                                <span class="txt">{{item.ac_secret_key}}</span>
                            </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" >
                            <div class="a">
                                <span style="font-size: 14px;">关联车场：</span>
                                <el-link type="success" @click="Detail(item.ac_id)">查看</el-link>
                            </div>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" >
                            <div class="a">
                                <span style="font-size: 14px;">应用状态：</span>
                                <el-tag type="danger" v-if="item.ac_state===0">禁用</el-tag>
                                <el-tag type="success" v-if="item.ac_state===1">启用</el-tag>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" >
                            <div class="right" style="float: right;margin-top: 15px;">
                                <el-button type="primary" plain @click='OpenApiConfig(item.ac_id,item.ac_name)'>接口配置</el-button>
                                <el-button type="success"  v-if="item.ac_state===0" plain @click='EditState(item.ac_id,1)'>启用</el-button>
                                <el-button type="danger"  v-if="item.ac_state===1" @click='EditState(item.ac_id,0)' plain>禁用</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>

        </div>





        <!--运用-->
        <el-dialog :title="title" :visible.sync="dialogVisible" width='50%' :append-to-body='true'>
           <el-form :model="configForm" :rules="rules" ref="configForm" label-width="100px" size='medium'>
                <el-form-item label="应用名称" prop="ac_name">
                    <el-input v-model="configForm.ac_name"></el-input>
                </el-form-item>
                <el-form-item label="应用简介">
                    <el-input v-model="configForm.ac_remark"></el-input>
                </el-form-item>
                <el-form-item label="关联车场">
                    <el-button type="primary"  @click="CheckParkClick"> 选择车场</el-button>
                </el-form-item>
           </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="选择车场" :visible.sync="parkDialogVisible" width='50%' :append-to-body='true'>
            <div>
                <el-card>
                    <el-input placeholder="请输入车场名称" v-model="searchForm.name" class="marg" style="width:200px;margin-right: 15px;"></el-input>
                    <el-button type="primary" class="el-icon-search marg" @click="FindClick"> 查询</el-button>
                </el-card>
                <div class="t tt">
                    <el-table style="margin-top: 15px;" :data='parkDataList' ref='parkDataList' border stripe :highlight-current-row='true' @selection-change='handleSelectionChange'>
                        <el-table-column type="selection" width="50"></el-table-column>
                        <el-table-column align="center" prop="pk_name" label="名称"></el-table-column>
                        <el-table-column align="center" prop="pk_cloud_id" label="车场ID"></el-table-column>
                        <el-table-column align="center" prop="pk_cloud_ckey" label="车场秘钥"></el-table-column>
                    </el-table>
                    <el-pagination style="margin-top: 10px;" layout="prev, pager, next" @current-change="current_change" :total="searchForm.total" background :page-size="searchForm.pageSize"></el-pagination>
                </div>
            </div>
             <span slot="footer" class="dialog-footer">
                 <el-button @click="parkDialogVisible = false">取 消</el-button>
                 <el-button type="primary" @click="Confirm">确 定</el-button>
             </span>
         </el-dialog>
 

         <!--接口-->
         <el-dialog :title="title" :visible.sync="apiDialogVisible" width='50%' :append-to-body='true'>
            <div>
                <el-button type="primary" @click="AddApi" icon="el-icon-plus"> 新增</el-button>
                <el-table :data="ApiDataList" style="margin-top: 15px;" border stripe :highlight-current-row='true'>
                    <el-table-column align="center" label="接口名称">
                        <template slot-scope="scope">
                            {{BindName(scope.row.api_index)}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="api_url" label="接口URL"></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="EditApi(scope.row)">修改</el-link>
                            <el-link type="danger" @click="DelApi(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
             <span slot="footer" class="dialog-footer">
                 <el-button @click="apiDialogVisible = false">关 闭</el-button>
             </span>
         </el-dialog>


         <el-dialog title="接口信息" :visible.sync="openApiDialogVisible" width='50%' :append-to-body='true'>
            <el-form :model="openApiForm" ref="openApiForm" label-width="100px" size='medium'>
                <el-form-item label="应用名称">
                    <el-input v-model="openApiForm.ac_name" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="接口名称">
                    <el-select v-model="openApiForm.api_index">
                        <el-option v-for='item in apiArr' :key='item.value' :label="item.label" :value="item.value"></el-option>
                      </el-select>
                </el-form-item>
                <el-form-item label="url地址">
                    <el-input v-model="openApiForm.api_url"></el-input>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                 <el-button @click="openApiDialogVisible = false">取 消</el-button>
                 <el-button type="primary" @click="Save">确 定</el-button>
             </span>
         </el-dialog>
    </div>
</template>


<script>
import util from '../../util/util'

export default{
    data:function(){
        return{
            title:'',
            dialogVisible:false,

            DataList:[],

            configForm:{
                ac_id:0,
                ac_name:'',
                ac_remark:'',
                ac_park_id:[]
            },

            parkDataList:[],
            pageNo:1,
            isfirst:false,

            rules:{
                config_name:[{ required: true, message: '请输入运用名称', trigger: 'blur' }]
            },

            parkDialogVisible:false,

            searchForm:{
                name:'',
                pageSize: 10,
                pageNo: 1,
                total: 0
            },


            apiDialogVisible:false,
            ApiDataList:[],
            apiArr:[{
                label:'车辆入场记录',
                value:0
            },{
                label:'车辆出场记录',
                value:1
            },{
                label:'收费记录',
                value:2
            },{
                label:'剩余车位数上传',
                value:3
            },{
                label:'更新长期车信息',
                value:4
            },{
                label:'删除长期车',
                value:5
            },{
                label:'折扣记录上传',
                value:6
            },{
                label:'预付记录上传',
                value:7
            },{
                label:'延期信息上传',
                value:8
            },{
                label:'黑名单上传',
                value:9
            },{
                label:'设备信息上传',
                value:10
            },{
                label:'通道信息上传',
                value:11
            },{
                label:'车场信息上传',
                value:12
            }],
            openApiDialogVisible:false,
            openApiForm:{
                api_id:0,
                api_config_id:0,
                ac_name:'',
                api_index:0,
                api_url:''
            }

        }
    },
    computed:{
        FormData () {
            return function (time) {
                if(time===null||time===undefined||time==='')
                    return ''
                else
                    return util.FormateDate(time, 2)
            }
        },
        BindName(){
            return function(index){
                let name=''
                let arr= this.apiArr.filter(a=>a.value==index)
                if(arr.length>0){
                    name=arr[0].label
                }
                return name
            }
        }
    },
    created(){
        this.getDataList()
    },
    methods:{
        getDataList(){
            util.Get('apiconfig/getdatalist').then(res=>{
                if(res.rpStatus===10000){
                    this.DataList=res.list
                }
            })
        },
        getParkDataList(){
            util.Get('parkmanage/getparkdatalist',this.searchForm).then(res => {
                if (res.rpStatus === 10000) {
                    this.parkDataList=res.list[2]
                    this.searchForm.total=res.total

                        this.$nextTick(() => {
                            this.isfirst=true
                            this.parkDataList.forEach(row => {
                                let arr= this.configForm.ac_park_id.filter(a=>a===row.pk_id)
                                if(arr.length>0){
                                    this.$refs.parkDataList.toggleRowSelection(row, true);
                                }
                            });
                            this.isfirst=false
                        });
                }
            })
        },
        AddClick(){
            this.title='新增配置'
            this.dialogVisible=true
            this.configForm.ac_id=0
            this.configForm.ac_name=''
            this.configForm.ac_remark=''
            this.configForm.ac_park_id=[]
        },
        submit(){
            util.Post('apiconfig/edit',this.configForm).then(res=>{
                if(res.rpStatus===10000){
                    this.getDataList()
                    this.dialogVisible=false
                }
            })
        },
        Detail(id){
            let arr= this.DataList.filter(a=>a.ac_id===id)
            this.configForm.ac_id=id
            this.configForm.ac_name=arr[0].ac_name
            this.configForm.ac_remark=arr[0].ac_remark
            this.configForm.ac_park_id=JSON.parse(arr[0].ac_park_id)

            this.title='更新配置'
            this.dialogVisible=true
        },
        
        CheckParkClick(){
            this.parkDialogVisible=true
            this.getParkDataList()
        },
        current_change(page){
            this.searchForm.pageNo = page
            this.getParkDataList()
        },
        FindClick(){
            this.searchForm.pageNo=1
            this.getParkDataList()
        },
        handleSelectionChange(val){
            if(val.length>0){
                val.forEach(item=>{
                    let arr= this.configForm.ac_park_id.filter(a=>a===item.pk_id)
                    if(arr.length===0){
                        //添加
                        this.configForm.ac_park_id.push(item.pk_id)
                    }
                })
            }
            else{
                if(this.pageNo!==this.searchForm.pageNo){
                    this.pageNo=this.searchForm.pageNo
                    return
                }
            }
            if(!this.isfirst){
                this.parkDataList.forEach(item=>{
                    let arr=val.filter(a=>a.pk_id===item.pk_id)
                    if(arr.length===0){
                        //删除
                        let index = this.configForm.ac_park_id.indexOf(item.pk_id);
                        if(index !== -1){
                            this.configForm.ac_park_id.splice(index, 1);
                        }
                    }
                })
            }   
        },
        Confirm(){
            if(this.configForm.ac_park_id.length===0){
                this.$message.error('请选择车场')
            }
            else
                this.parkDialogVisible=false
        },
        EditState(id,state){
            util.Post('apiconfig/editstate',{
                ac_id:id,
                ac_state:state
            }).then(res=>{
                if(res.rpStatus===10000){
                    this.getDataList()
                    this.dialogVisible=false
                }
            })
        },

        //配置上传接口
        OpenApiConfig(id,name){
            this.apiDialogVisible=true
            this.title='接口配置'

            this.openApiForm.api_config_id=id
            this.openApiForm.ac_name=name

            this.getApiDataList()

        },
        getApiDataList(){
            util.Get('apiopen/getdatalist?id='+this.openApiForm.api_config_id).then(res=>{
                if(res.rpStatus===10000){
                    this.ApiDataList=res.list
                }
                else
                    this.$message.error(res.rpMsg)
            })
        },
        AddApi(){
            this.openApiDialogVisible=true
            this.openApiForm.api_id=0
            this.openApiForm.api_index=0
            this.openApiForm.api_url=''
        },
        EditApi(row){
            this.openApiDialogVisible=true
            this.openApiForm.api_id=row.api_id
            this.openApiForm.api_index=row.api_index
            this.openApiForm.api_url=row.api_url
        },
        DelApi(row){
            this.$confirm('确定删除接口“' + this.BindName(row.api_index) + '”？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                util.Get('apiopen/del?id='+row.api_id).then(res=>{
                    if(res.rpStatus===10000){
                        this.getApiDataList()
                        this.$message.success('删除成功')
                    }
                    else{
                        this.$message.error(res.rpMsg)
                    }
                })
            }).catch(e => e)
            
        },
        Save(){
            util.Post('apiopen/edit',this.openApiForm).then(res=>{
                if(res.rpStatus===10000){
                    this.getApiDataList()
                    this.openApiDialogVisible=false
                    this.$message.success('api配置成功')
                }else{
                    this.$message.error(res.rpMsg)
                }
            })
            
        }
    }
}

</script>


<style>
.t{
    /* display: flex;
    flex-direction: column; */
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
}
.tt{
    align-items: center;
}

.a{
    display: flex;
    flex-direction: row;
    /* justify-content: space-between;*/
    align-items: center; 
}
.left{
    margin-left: 50px;
}
.right{
    margin-right: 50px;
}
.txt{
    font-size: 13px;
    color: #676A6C;
}
.el-link{
    margin-right: 10px;
    font-size: 12px;
}
</style>